import {
  evolve, lensPath, compose, set
} from 'ramda';

import { successEvolve, requestEvolve, failEvolve } from 'src/store/reducers/reducerUtill';

export const lawChecksActions = {
  request: 'LAW_CHECKS_REQUEST',
  success: 'LAW_CHECKS_SUCCESS',
  fail: 'LAW_CHECKS_FAIL',
  refresh: 'LAW_CHECKS_REFRESH'
};

export const requestLawChecks = (payload) => ({
  type: lawChecksActions.request,
  payload
});

export const refreshLawChecks = () => ({
  type: lawChecksActions.refresh
});

const initialState = {
  list: [],
  pending: false,
  errors: []
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case lawChecksActions.request: {
      return evolve(requestEvolve, state);
    }
    case lawChecksActions.fail: {
      return evolve(failEvolve(payload), state);
    }
    case lawChecksActions.success: {
      return compose(
        evolve(successEvolve),
        set(lensPath(['list']), payload)
      )(state);
    }
    case lawChecksActions.refresh: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
